import { render, staticRenderFns } from "./LivePay.vue?vue&type=template&id=87705910&"
import script from "./LivePay.vue?vue&type=script&lang=js&"
export * from "./LivePay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports